// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import { protocol, origin } from './addons'

// ------------------------------------
// Actions
// ------------------------------------

export const getVoteToken = () => {
    return (dispatch) => {
      return new Promise((resolve) => {
        return new Promise((resolve) => {
          axios.get(`${protocol}//${origin}/api/vote/vote`)
            .then((json) => {
              localStorage.setItem('brave_vote', json.data.token)
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
      })
    }
  }

  export const vote = (object) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        return new Promise((resolve) => {
          axios.post(`${protocol}//${origin}/api/vote/vote?p1=${object.project1star || 'none'}&p2=${object.project2star || 'none'}&p3=${object.project3star || 'none'}&ip=${object.ip}`, object)
            .then((json) => {
              localStorage.setItem('braveImVoted', 'true')
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
      })
    }
  }

export const actions = { getVoteToken, vote }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}

export default function voteReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/vote.js